import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import {
  Breadcrumbs,
  Flex,
  FlexColumn,
  FlexSpace,
  GenerateAIButton,
} from '@elementary/common-ui/components';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import IncidentOverviewSidePanel from 'incidents/OverviewSidePanel';
import IncidentTable from 'incidents/Table';
import MergeIncidentsPage from 'incidents/MergeIncidentsPage';
import useOpenIncidentChatFromUrl from 'incidents/hooks/useOpenIncidentChatFromUrl';
import useJiraProjectFields from 'shared/components/ticketing/useJiraProjectFields';
import { space } from '@elementary/common-ui/style/utils';
import IncidentSettingsMenu from './IncidentSettingsMenu';

const Wrapper = styled(FlexColumn)`
  padding: ${space('xxl', 'xxl', 0, 'xxl')};
  gap: ${space('xxl')};
  overflow: hidden;
  height: 100%;
  min-width: 930px;
`;

const Incidents = () => {
  const envId = useSelectedEnv();
  const { data: account } = useAccount();
  useJiraProjectFields(envId);
  useOpenIncidentChatFromUrl();

  return (
    <Routes>
      <Route path="merge" element={<MergeIncidentsPage />} />
      <Route
        index
        element={
          <>
            <Wrapper>
              <FlexSpace>
                <Breadcrumbs items={['Response & Triage', 'Incidents']} />
                <Flex sx={{ gap: 1, alignItems: 'center' }}>
                  {account?.ai_features_enabled && (
                    <GenerateAIButton>Manage incidents</GenerateAIButton>
                  )}
                  <IncidentSettingsMenu />
                </Flex>
              </FlexSpace>
              <IncidentTable />
            </Wrapper>
            <IncidentOverviewSidePanel />
          </>
        }
      />
    </Routes>
  );
};

export default Incidents;
